import { Container, Spinner } from "react-bootstrap";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { usePage } from "../../hooks/usePage";
import useEvents from "../../hooks/useEvents";
import { usePrecargaEvents } from "../../hooks/usePrecargaEvents";
import CreatePrecargaEventForm from "./CreatePrecargaEventForm";

export default function PrecargasCreate() {
  usePage({ title: "Precargas" });

  const { eventid } = useParams();
  const navigate = useNavigate();
  const { event: cashlessEvent } = useEvents();
  const cashlessEventId = eventid ? parseInt(eventid) : null;

  const { isLoadingPrecargaEvent, hasPrecargaEvent } = usePrecargaEvents({
    cashlessEventId,
  });

  if (isLoadingPrecargaEvent) {
    return (
      <Container fluid>
        <div className="text-center p-5">
          <Spinner animation="border" />
          <p className="mt-3">Cargando configuración de precarga...</p>
        </div>
      </Container>
    );
  }

  if (!eventid) {
    return null;
  }

  if (hasPrecargaEvent) {
    return <Navigate to={`/${eventid}/preloads/detail`} replace />;
  }

  return (
    <Container fluid>
      <h2>Configurar Precarga</h2>
      <p className="text-muted mb-4">
        Configure las opciones de precarga para el evento:{" "}
        <strong>{cashlessEvent?.name}</strong>
      </p>
      <CreatePrecargaEventForm
        cashlessEventId={parseInt(eventid)}
        onSuccess={() => navigate(`/${eventid}/preloads/detail`)}
      />
    </Container>
  );
}
